export default "__VITE_ASSET__Ciwc11lf__"